import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
// import { useDeleteStore, useListStore } from "../stores";
import { toast } from 'react-toastify';
import { useMediaQuery } from 'react-responsive';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
// import { lte } from "lodash";
import { useSelector } from 'react-redux';
import moment from 'moment';

export function CardList({ customers, search, sortData }) {
  console.log('ini search', search);
  console.log('ini sort', sortData);
  parseInt(sortData);
  const [load, setLoad] = useState(false);
  // const [stateDelete, actionsDelete] = useDeleteStore();
  // const [state, actionsList] = useListStore();

  // const customers = useSelector((state) => state.redCustomer);

  const handleDelete = async (customer) => {
    confirmAlert({
      title: 'Confirm to delete',
      message: `Are you sure want to delete "${customer.name}"`,
      buttons: [
        {
          label: 'Delete',
          onClick: async () => {
            // actionsDelete.deleteData({ id: customer.id }, () => {
            //   toast.warning(`Delete data "${customer.name}"`);
            //   actionsList.loadData();
            // });
          },
        },
        {
          label: 'Cancel',
          onClick: () => {},
        },
      ],
    });
  };

  useEffect(() => {
    const load = setTimeout(() => {
      setLoad(true);
    }, 3000);
    return () => clearTimeout(load);
  }, []);

  const baseImg =
    'https://cdn.pixabay.com/photo/2017/06/09/07/42/flower-2386049_960_720.jpg';

  const handleImgError = (e) => {
    // e.target.src = baseImg + '/doctor/dr.jpg';
  };

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 });
    return isDesktop ? children : Default;
  };
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    return isTablet ? children : null;
  };
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };
  const Default = ({ children }) => {
    const isNotTabletAndMobile = useMediaQuery({
      minWidth: 768,
      maxWidth: 990,
    });
    return isNotTabletAndMobile ? children : null;
  };

  const getInitials = function (string) {
    if (string) {
      var names = string ? string.split(' ') : '',
        initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    }
  };

  const sortIt = (sortData) => (a, b) => {
    if (a[sortData] > b[sortData]) {
      return 1;
    } else if (a[sortData] < b[sortData]) {
      return -1;
    }
    return 0;
  };

  let contentUi = <div className='loader-block' />;
  if (load) {
    contentUi = (
      <>
        <section>
          <div className='ml-auto'>
            <div className='w-full mb-4'>
              <Desktop>
                <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg '>
                  <div className='px-6 py-4'>
                    <div className='grid lg:grid-cols-6'>
                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Photo</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Customer Name</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Email Customer</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Subscription</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Created At</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Action</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Desktop>
            </div>

            {load
              ? customers
                  .filter((customer) => {
                    if (!search) return true;
                    if (
                      customer.name.toLowerCase().includes(search) ||
                      customer.name.toLowerCase().includes(search) ||
                      customer.name.toUpperCase().includes(search) ||
                      customer.name.toUpperCase().includes(search)
                    ) {
                      return true;
                    }
                  })
                  .map((customer, i) => (
                    <>
                      <Desktop>
                        <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                          <div className='grid  lg:grid-cols-6'>
                            <div className='px-4  bg-white flex items-center rounded'>
                              <div className='avatar sm:w-28 sm:h-28 md:w-28 md:h-28 xl:w-28 xl:h-28 2xl:w-28 2xl:h-28'>
                                {customer.name
                                  ? getInitials(customer.name)
                                  : null}
                              </div>
                            </div>
                            <div className='px-4  bg-white flex items-center rounded'>
                              <Link
                                to={`/customer-management/detail/${customer.id}`}
                              >
                                <p className='font-bold text-left '>
                                  {customer.name}
                                </p>
                              </Link>
                            </div>
                            <div className='px-4  bg-white flex items-center rounded'>
                              <p className='font-bold'>{customer.email}</p>
                            </div>
                            <div className='px-4 bg-white flex items-center rounded'>
                              <div>
                                {customer.subscriptions.length === 0
                                  ? 'Free Customer'
                                  : 'Pro Customer'}
                              </div>
                            </div>

                            <div className='px-4  bg-white flex items-center rounded'>
                              {/* <p className='font-bold'>{customer.createdAt}</p> */}
                              <div>
                                <p className='font-bold'>
                                  {moment(
                                    `${customer.createdAt}`,
                                    'YYYYMMDDHHmm'
                                  ).format('HH:mm A')}
                                </p>
                                {/* <br /> */}
                                <p className='text-xs'>
                                  {moment(
                                    `${customer.createdAt}`,
                                    'YYYYMMDDHHmm'
                                  ).format('DD/MM/YYYY')}
                                </p>
                              </div>
                            </div>
                            <div className='px-4 items-center rounded my-auto'>
                              <div className='flex items-center'>
                                <div className='flex items-center'>
                                  {/* <Link
                                    to={`/customer-management/edit/${customer.id}`}
                                    className='btn btn-icon btn_outlined btn_secondary'
                                  >
                                    <span className='la la-pen-fancy'></span>
                                  </Link> */}
                                  <button
                                    type='button'
                                    className='btn btn-icon btn_outlined btn_danger ml-2'
                                    onClick={(e) => handleDelete(customer)}
                                  >
                                    <span className='la la-trash-alt'></span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Desktop>

                      <Tablet>
                        <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                          <div className='px-2 py-2 border-b'>{/*  */}</div>
                          <div className='grid py-6 lg:grid-cols-5 space-y-2'>
                            <div className='px-4 bg-white flex items-center justify-center rounded '>
                              {/* <Link
                                to={`/customer-management/detail/${customer.id}`}
                              > */}
                              <div className='items-center gap-3 max-w-xs'>
                                <div>
                                  <div className='avatar w-20 h-20'>
                                    {customer.name
                                      ? getInitials(customer.name)
                                      : null}
                                  </div>
                                </div>
                              </div>
                              {/* </Link> */}
                            </div>
                            <div className='px-4 bg-white flex items-center justify-center rounded'>
                              <Link
                                to={`/customer-management/detail/${customer.id}`}
                              >
                                <div className='items-center gap-3 max-w-xs'>
                                  <div>
                                    <div>
                                      <p className='font-bold text-md'>
                                        {customer.name}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>

                            <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                              <div className='items-center gap-3 max-w-xs'>
                                <div>
                                  <div>
                                    <p className='font-bold text-xs'>
                                      {customer.email}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            <p className='text-center text-xs'>
                              Joined At{' '}
                              {moment(
                                `${customer.createdAt}`,
                                'YYYYMMDDHHmm'
                              ).format('DD/MM/YYYY')}
                            </p>
                            <hr />
                            <p className='text-center text-xs'>
                              {customer.subscriptions.length === 0
                                ? 'Free Customer'
                                : 'Pro Customer'}
                            </p>
                          </div>
                          <hr />
                          <Table
                            className='table border-none justify-center align-center mx-auto'
                            style={{ border: 'none !important' }}
                          >
                            <Tbody style={{ border: 'none !important' }}>
                              <Tr key={i} style={{ border: 'none !important' }}>
                                <Td className='items-center flex justify-center w-full'>
                                  {/* <div>
                                    <Link
                                      to={`/customer-management/edit/${customer.id}`}
                                      className='btn btn-icon btn_outlined btn_secondary'
                                    >
                                      <span className='la la-pen-fancy'></span>
                                    </Link>
                                  </div> */}
                                  <div>
                                    <button
                                      type='button'
                                      className='btn btn-icon btn_outlined btn_danger ml-2'
                                      onClick={(e) => handleDelete(customer)}
                                    >
                                      <span className='la la-trash-alt'></span>
                                    </button>
                                  </div>
                                </Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        </div>
                      </Tablet>

                      <Mobile>
                        <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                          <div className='px-2 py-2 border-b'>{/*  */}</div>
                          <div className='grid py-6 lg:grid-cols-5 space-y-2'>
                            <div className='px-4 bg-white flex items-center justify-center rounded '>
                              {/* <Link
                                to={`/customer-management/detail/${customer.id}`}
                              > */}
                              <div className='items-center gap-3 max-w-xs'>
                                <div>
                                  <div className='avatar w-20 h-20'>
                                    {customer.name
                                      ? getInitials(customer.name)
                                      : null}
                                  </div>
                                </div>
                              </div>
                              {/* </Link> */}
                            </div>
                            <div className='px-4 bg-white flex items-center justify-center rounded'>
                              <Link
                                to={`/customer-management/detail/${customer.id}`}
                              >
                                <div className='items-center gap-3 max-w-xs'>
                                  <div>
                                    <div>
                                      <p className='font-bold text-md'>
                                        {customer.name}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>

                            <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                              <div className='items-center gap-3 max-w-xs'>
                                <div>
                                  <div>
                                    <p className='font-bold text-xs'>
                                      {customer.email}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            <p className='text-center text-xs'>
                              Joined At{' '}
                              {moment(
                                `${customer.createdAt}`,
                                'YYYYMMDDHHmm'
                              ).format('DD/MM/YYYY')}
                            </p>
                            <hr />
                            <p className='text-center text-xs'>
                              {customer.subscriptions.length === 0
                                ? 'Free Customer'
                                : 'Pro Customer'}
                            </p>
                          </div>
                          <hr />
                          <Table
                            className='table border-none justify-center align-center mx-auto'
                            style={{ border: 'none !important' }}
                          >
                            <Tbody style={{ border: 'none !important' }}>
                              <Tr key={i} style={{ border: 'none !important' }}>
                                <Td className='items-center flex justify-center w-full'>
                                  {/* <div>
                                    <Link
                                      to={`/customer-management/edit/${customer.id}`}
                                      className='btn btn-icon btn_outlined btn_secondary'
                                    >
                                      <span className='la la-pen-fancy'></span>
                                    </Link>
                                  </div> */}
                                  <div>
                                    <button
                                      type='button'
                                      className='btn btn-icon btn_outlined btn_danger ml-2'
                                      onClick={(e) => handleDelete(customer)}
                                    >
                                      <span className='la la-trash-alt'></span>
                                    </button>
                                  </div>
                                </Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        </div>
                      </Mobile>
                    </>
                  ))
              : null}
          </div>
        </section>
      </>
    );
  }

  return contentUi;
}
